<template>
    <div class="article-blog-yorkshire">
        <p>
            Looking for West Coast Swing in Yorkshire? You've come to the right place! There's a buzzing little scene if
            you know where to look. If you're really bitten by the bug, you can dance four nights a week in the area.
        </p>
        <p>
            <strong>Tuesday </strong>nights it's all about our very own
            <a href="/" class="nuxt-link-active" rel="noopener noreferrer nofollow">Swing Renegades</a> classes held in
            Headingley, Leeds. We specialise in getting beginners up dancing at their first class! No matter what you're
            level, we have something for you.
        </p>
        <p>
            Plus&nbsp;on <strong>Wednesdays</strong>, there's a beginner class in Morley with Matthew Brooke, who works
            hard to give people a solid grounding in the fundamentals. Drop
            <a href="https://www.facebook.com/matthew.brooke.904" target="_blank" rel="noopener noreferrer nofollow"
                >Matthew Brooke</a
            >
            a message on Facebook to get the latest info about his classes.
        </p>
        <p>
            On <strong>Thursday</strong> nights in Bradford, Curly Wurly Events host classes from beginner through to
            intermediate, and a great little social. What's more, organiser Lisa Graydon is GPDIA Intermediate level
            trained and has 16 years' experience teaching different swing dances and creates a fun environment and great
            sense of community - so head down early for the classes. Check
            <a href="http://www.curlywurlyevents.com/" target="_blank" rel="noopener noreferrer nofollow"
                >Curly Wurly Events</a
            >
            for more info. Hats off to Lisa too, she brings international teachers to the area three times a year.
        </p>
        <p>
            Finally, the weekend hosts some great social nights from time to time - and the area regularly hosts world
            renowned teachers at one off events. The best place for news from the area and the wider scene? Jump on the
            <a href="https://www.facebook.com/groups/48156491206/" target="_blank" rel="noopener noreferrer nofollow"
                >WCS Leeds &amp; Yorkshire</a
            >
            Facebook Group.
            <a
                href="https://www.facebook.com/groups/1097920376952796/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                >WCS Up North</a
            >
            is also a great source of information.
        </p>
        <p>
            <em>Run a West Coast Swing group in Yorkshire? Please </em
            ><a href="/contact/" class="" rel="noopener noreferrer nofollow"><em>let us know</em></a
            ><em> and we'll add you to the list!</em>
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleBlogYorkshire',
};
</script>
